/*
  Wholey Loop Product Modal
  Zentrales Produktdetail-Modal, genutzt vom Bundle Builder und vom
  PDP-Upsell. Der Inhalt kommt aus <template data-bundle-detail="{productId}">-
  Elementen, die snippets/loop-bundle-detail.liquid pro Produkt rendert.
*/
(function () {
  'use strict';

  if (customElements.get('loop-product-modal')) return;

  class LoopProductModal extends HTMLElement {
    // Singleton am document.body: Markup lebt hier statt in Liquid, damit
    // jede Einbindung (Builder, Upsell) exakt dasselbe Modal bekommt
    static getOrCreate() {
      let modal = document.querySelector('loop-product-modal');
      if (!modal) {
        modal = document.createElement('loop-product-modal');
        modal.innerHTML = `
          <dialog class="loop-bb__modal" aria-label="Produktdetails">
            <button type="button" class="loop-bb__modal-close" data-close-modal aria-label="Schließen">&times;</button>
            <div class="loop-bb__modal-body" data-modal-body></div>
          </dialog>`;
        document.body.appendChild(modal);
      }
      return modal;
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-modal-body]');
      this.addEventListener('click', this.onClick.bind(this));
      // Klick auf den Backdrop (das dialog-Element selbst) schließt
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    onClick(event) {
      const step = event.target.closest('[data-modal-quantity-change]');
      if (step) {
        const value = this.querySelector('[data-modal-quantity]');
        if (value) {
          const next = Math.max(1, (parseInt(value.textContent, 10) || 1) + parseInt(step.dataset.modalQuantityChange, 10));
          value.textContent = next;
          const minus = this.querySelector('[data-modal-quantity-change="-1"]');
          if (minus) minus.disabled = next <= 1;
        }
        return;
      }

      const add = event.target.closest('[data-add-from-modal]');
      if (add) {
        const value = this.querySelector('[data-modal-quantity]');
        const quantity = Math.max(1, parseInt(value?.textContent, 10) || 1);
        this.dialog.close();
        if (typeof this.onAdd === 'function') this.onAdd(add.dataset.addFromModal, quantity);
        return;
      }

      if (event.target.closest('[data-close-modal]')) this.dialog.close();
    }

    // options.onAdd(variantId, quantity) bestimmt, was der Hinzufügen-Button
    // tut — der Bundle Builder legt ins Bundle, das PDP-Upsell in den Warenkorb
    open(productId, options = {}) {
      const template = document.querySelector(`template[data-bundle-detail="${productId}"]`);
      if (!template) return;
      this.onAdd = options.onAdd || null;
      this.body.innerHTML = '';
      this.body.appendChild(template.content.cloneNode(true));
      // aus <template> geklonte lazy-Bilder bleiben sonst teils ungeladen hängen
      this.body.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
        if (!img.complete || !img.naturalWidth) img.src = img.getAttribute('src');
      });
      this.dialog.showModal();
      // Judge.me muss die frisch eingefügte Sterne-Badge initialisieren
      if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
        window.jdgm.customizeBadges();
      }
    }
  }

  customElements.define('loop-product-modal', LoopProductModal);
})();
